export const TSIZE = 256;

export default class Projection {
  async init() {
    // override in subclass
  }

  zoomToScale(zoom) {
    return Math.pow(2, zoom);
  }

  scaleToZoom(scale) {
    return Math.log(scale) / Math.LN2;
  }

  /**
   * @param points {[number, number][][]}
   * @returns {[[number, number], [number, number]]}
   */
  calcBounds(points) {
    let minLat = Infinity;
    let minLng = Infinity;
    let maxLat = -Infinity;
    let maxLng = -Infinity;

    points.forEach(s => s.forEach(([lat, lng]) => {
      minLat = Math.min(lat, minLat);
      minLng = Math.min(lng, minLng);
      maxLat = Math.max(lat, maxLat);
      maxLng = Math.max(lng, maxLng);
    }));

    return [
      [minLat, minLng],
      [maxLat, maxLng]
    ];
  }

  /**
   * @param param0 {[[number, number], [number, number]]}
   * @returns {[number, number]}
   */
  calcCenter([
    [minLat, minLng],
    [maxLat, maxLng]
  ]) {
    return [
      (minLat + maxLat) / 2, (minLng + maxLng) / 2
    ];
  }

  getScaleZoom(scale, zoom) {
    return this.scaleToZoom(scale * this.zoomToScale(zoom));
  }
}
